import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=64828f9b&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64828f9b",
  null
  
)

export default component.exports